/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6f306351"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6f306351&lang=less"

import exportComponent from "E:\\vuewebpage3\\ydqbyg-dz2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__